import Hanchor from "./Hanchor"
import { useEffect, useState } from 'react';
import HomeIntro from "./HomeIntro";


export default function Home() { 
  const [hanchor, setHanchor] = useState('hanchor')
  let content;
  useEffect(() => {
    setTimeout(()=>{
      setHanchor('notHanchor')
    }, 3000)
  }, [])
  if(hanchor==='hanchor'){
    content = <Hanchor />
  }else{
    content = <HomeIntro />
  }

  return (
    <div>
      {content}
    </div>
  )
}
